module.exports = __webpack_public_path__ + "img/10784@3x.4b8a52b2.png";